import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

const mock = [
  { category: 'rzp', paid: 1000000, accrued: 4800000 },
  { category: 'finesAndPenalties', paid: 2800000, accrued: 8200000 },
  { category: 'unaccountedVolumes', paid: 3800000, accrued: 4600000 },
];

const index = new AxiosMockAdapter(instance);

index
  .onGet(/\/api\/payments-status-by-type-of-accruals.*/)
  .reply(200, mock)
  .onAny()
  .passThrough();
